import { Component, inject } from '@angular/core';
import { Upload } from '../../../core/models/upload.model';
import { PatientInteractionLocationImportsService } from '../../../core/services/patient-interaction-location-imports.service';
import { Router } from '@angular/router';
import { HttpErrorResponse } from '@angular/common/http';
import { isEmpty } from 'lodash-es';
import { ImportNavComponent } from '../../../shared/components/import-nav/import-nav.component';

import { FileUploadComponent } from '../../../shared/components/file-upload/file-upload.component';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';

@Component({
    selector: 'app-capture-admin-import-patient-interaction-locations',
    templateUrl: './capture-admin-import-patient-interaction-locations.component.html',
    styleUrls: ['./capture-admin-import-patient-interaction-locations.component.scss'],
    imports: [ImportNavComponent, FileUploadComponent, FaIconComponent]
})
export class CaptureAdminImportPatientInteractionLocationsComponent {
  private patientInteractionLocationImportsService = inject(PatientInteractionLocationImportsService);
  private router = inject(Router);

  uploading = false;
  formModel = {};
  errors: string[] = [];

  onUploadStart() {
    this.uploading = true;
    this.errors = [];
  }

  onUploadCancel() {
    this.uploading = false;
  }

  onUploadComplete(upload: Upload) {
    this.patientInteractionLocationImportsService.create(upload.signedId).subscribe(
      () => {
        this.router.navigate(['/capture-admin/tools/import-patient-interaction-locations/history']);
        this.uploading = false;
      },
      (error: HttpErrorResponse) => {
        this.uploading = false;
        this.errors = error.error.errors;
      }
    );
  }

  onUploadError() {
    this.uploading = false;
  }

  onFormEnter($event) {
    $event.preventDefault();
  }

  public get hasError() {
    return !isEmpty(this.errors);
  }
}
